export enum SelectorType {
    RADIO,
    CHECKBOX,
}



// WEBPACK FOOTER //
// ./src/app/inputs/selector-control/selector.ts